import { useLocation, Link } from 'react-router-dom';
import Layout from '../components/Layout';

function useQ() {
  const { search } = useLocation();
  return Object.fromEntries(new URLSearchParams(search));
}

export default function Confirmation() {
  const q = useQ();
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-2xl">
        <h1 className="text-3xl font-semibold mb-4">You’re booked!</h1>
        <div className="rounded-2xl border border-gray-200 bg-white p-6 text-gray-800">
          <div className="text-sm text-gray-500">Confirmation Code</div>
          <div className="text-2xl font-bold mb-4">{q.code || '—'}</div>

          <div className="space-y-1">
            <div><span className="font-semibold">Route:</span> {q.dest || '—'}</div>
            <div><span className="font-semibold">Passengers:</span> {q.pax || '—'}</div>
            <div><span className="font-semibold">Trip:</span> {q.trip || '—'}</div>
            <div className="mt-2"><span className="font-semibold">Outbound:</span> {q.out_date} {q.out_time}</div>
            {q.trip === 'return' && (
              <div><span className="font-semibold">Return:</span> {q.ret_date} {q.ret_time}</div>
            )}
          </div>

          <div className="mt-6">
            <Link to="/" className="inline-block rounded-full px-5 py-2 bg-blue-600 text-white hover:bg-blue-700">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
